module.exports = {"name":"youtube","type":"adapter","tech":"js","author":"Marc Maycas","version":"6.1.0","built":"2017-10-25","repo":"https://bitbucket.org/npaw/youtube-adapter-js","libVersion":"6.1.0","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getRendition","getTitle","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0